import React__default from 'react';

/**
 * Render the root element of the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Root(props) {
    const { rootRef, ...rest } = props;
    return React__default.createElement("div", { ...rest, ref: rootRef });
}

export { Root };
